import { render } from "./App.vue?vue&type=template&id=1ccbbb46"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=1ccbbb46&lang=scss"

import exportComponent from "/Users/william/Documents/beadographer3/bead3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__